export default "__VITE_ASSET__B55GW6Y2__"